import React, { useMemo } from "react";
import { selectFormat } from "components/Utils/Utils";
import { HeatMapGrid } from "react-grid-heatmap";

const Heatmap = (props) => {
  const xLabels = new Array(24).fill(0).map((_, i) => `${i}`);
  const yLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const newData = useMemo(() => {
    const tempData = [];
    props.data.data.forEach((e) => {
      if (!tempData[Number(e.day_of_week) - 1])
        tempData[Number(e.day_of_week) - 1] = new Array(24).fill(0);
      tempData[Number(e.day_of_week) - 1][Number(e.hour_of_day)] =
        e.views_unique.value;
    });
    return tempData;
  }, [props.data.data]);

  return (
    <div
      style={{
        width: "100%",
        fontFamily: "sans-serif",
      }}
    >
      <HeatMapGrid
        data={newData}
        xLabels={xLabels}
        yLabels={yLabels}
        // Reder cell with tooltip
        cellRender={(x, y, value) => <div>{selectFormat("number", value)}</div>}
        xLabelsStyle={(index) => ({
          color: index % 2 ? "transparent" : "#777",
          fontSize: ".65rem",
        })}
        yLabelsStyle={() => ({
          fontSize: ".65rem",
          textTransform: "uppercase",
          color: "#777",
        })}
        cellStyle={(_x, _y, ratio) => ({
          background: `rgb(252, 109, 82, ${ratio})`,
          fontSize: ".7rem",
          color: `rgb(0, 0, 0, ${ratio / 2 + 0.4})`,
        })}
        cellHeight="1.5rem"
        xLabelsPos="bottom"
      />
    </div>
  );
};

export default Heatmap;
